export function BMapLoader() {
  return new Promise((resolve, reject) => {
    if (window.BMapGL) {
      resolve(window.BMapGL)
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://api.map.baidu.com/api?v=1.0&type=webgl&callback=initBMap&ak=FPjs8vx4eb6bOfoaZyl8POgSa25DOFK2'
      script.async = true
      script.onerror = reject
      document.head.appendChild(script)
    }
    window.initBMap = function () {
      resolve(window.BMapGL)
    }
  })
}

export function BMapGLLibLoader() {
return new Promise((resolve, reject) => {
  if (window.BMapGLLib) {
    resolve(window.BMapGLLib)
  } else {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://api.map.baidu.com/library/TrackAnimation/src/TrackAnimation_min.js'
    script.async = true
    script.onerror = reject
    document.head.appendChild(script)
  }
})
}
